import * as React from "react";
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";
import SystemCrash from "./SystemCrash";
import { LogReactError } from "../../api/loggingApi";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class MainErrorBoundary extends React.Component {

    static getDerivedStateFromError(error) {
        //debugger;
        return { hasError: true };
    }

    constructor(props) {
        super(props);
        //debugger;
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        //debugger;
        this.setState({ hasError: true });
        //let json = { error: error, componentStack: info };
        //logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(info));
    }

    render() {
        if (this.state.hasError) {
            //debugger;
            return <SystemCrash />;
        }

        return this.props.children;
    }
}


export default MainErrorBoundary;